'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * Detect if the user clicked (`mousedown` or `touchstart`) inside a React `ref` `HTMLElement`.
 * @param options UseClickInsideOptions<T>
 * @returns UseClickInsideState
 */ const useClickInside = (options)=>{
    const { callback , delay =300 , ref  } = options;
    const savedCallback = React.useRef(callback);
    const [clickedInside, setClickedInside] = React.useState(false);
    React.useEffect(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    React.useEffect(()=>{
        if (clickedInside && delay > -1) {
            setTimeout(()=>{
                setClickedInside(false);
            }, delay);
        }
    }, [
        clickedInside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        const listener = (e)=>{
            const { current  } = ref;
            // clicked inside the ref
            if (current && current.contains(e?.target)) {
                setClickedInside(true);
                if (savedCallback.current) {
                    savedCallback.current(e);
                }
            } else {
                setClickedInside(false);
            }
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return ()=>{
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [
        ref
    ]);
    return {
        clickedInside
    };
};

exports.useClickInside = useClickInside;
//# sourceMappingURL=use-click-inside.js.map
